import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Flex } from '@costar/theme-ui';
import React from 'react';

var _excluded = ["children"];
var ColumnWrapper = function ColumnWrapper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'lg' : _props$gap,
    _props$justifyContent = props.justifyContent,
    justifyContent = _props$justifyContent === void 0 ? 'end' : _props$justifyContent;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Flex, _extends({
    justifyContent: justifyContent,
    gap: gap,
    alignItems: "center"
  }, props), children);
};

export default ColumnWrapper;
//# sourceMappingURL=column-wrapper.esm.js.map
